import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

export const TextInput = styled(TextField)(({ theme }) => ({
    minWidth: 300,
    textAlign: 'center',
    margin: 8,
}));
